module.exports = __webpack_public_path__ + "assets/arrow-thin-right.78a58e87.svg";